import { Button } from "@mui/material";
import { MODALS } from "modals";
import React from "react";
import { useDispatch } from "react-redux";
import { modalsActions } from "store/react-lib/generic-ui/modals";

export default function ManageFriendsButton() {

  const dispatch = useDispatch();

  return (
    <Button
      color="primary"
      variant="contained"
      onClick={() => dispatch(modalsActions.openModal(MODALS.manageFriendsModal))}
    >
      Manage Friends
    </Button>
  );
}
